import React, { useEffect } from 'react';
import { ContactGuestModal, PContactGuestModal } from './ContactGuestModal';
import { useFetch } from 'src/utils/hooks/useFetch';
import { InterviewApi } from 'src/api/base/Interviews';
import { useResponseFormHandler } from 'src/utils/hooks/useResponseFormHandler';

type PContactGuestModalContainer = Pick<
  PContactGuestModal,
  'open' | 'onClose'
> & {
  guestId: string;
  onSuccess?: () => void;
};

export const ContactGuestModalContainer: React.FC<PContactGuestModalContainer> =
  (props) => {
    const { guestId, open, onClose, onSuccess } = props;
    const [{ response, isLoading, error }, doFetch] = useFetch(
      InterviewApi.makeInterviewRequest,
    );

    useResponseFormHandler({ response, error });

    useEffect(() => {
      if (response && onSuccess) {
        onSuccess();
      }
      // onSuccess doesnt play any role in this case
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [response]);

    return (
      <ContactGuestModal
        onSubmit={(data) => {
          doFetch({ guest_id: guestId, ...data });
        }}
        loading={isLoading}
        open={open}
        onClose={onClose}
        errors={error}
      />
    );
  };
